import CustomPage from './CustomPage';

export default CustomPage;
